import { render, staticRenderFns } from "./FieldConfig.vue?vue&type=template&id=33d736cf&scoped=true"
import script from "./FieldConfig.vue?vue&type=script&lang=js"
export * from "./FieldConfig.vue?vue&type=script&lang=js"
import style0 from "./FieldConfig.vue?vue&type=style&index=0&id=33d736cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d736cf",
  null
  
)

export default component.exports